import React from 'react';
import { connect } from 'react-redux';
import './otp_screen_component.scss';
import { authenticateOtp, verifyPasswordResetOtp, signInUser, regenerateOtp, resetPasswordOtp } from '../../../../gateway/api';
import {error, success} from "../../../../util/pnotify";
import validate from "validate.js";
import classnames from 'classnames';
// import get from "lodash/get";
import { otpConstraints } from '../../../../util/validation_constraints';
import { showCloseButtonClass, errorClass, clearInputContent } from '../../../../util/form_login_utils';
import ErrorMessageComponent from '../get_error_message';
import ApiErrorMessageComponent from '../get_api_error_message';

const OtpScreen = ({loginObj={}, onButtonClick, handleChange, passwordReset, resetOtpHandler, errors, source, clearInput, apiErrors, userLogin, action}) => {
  return (
    <div className="otp-container">
    {otpScreenHeader(passwordReset, loginObj)}
    <div className="input-field-container" id="input-field-container">
      <label htmlFor="textInput" className="input-label">Enter OTP</label>
      <div className="field">
        <input type="number"
               className={`input-field-box ${errorClass(errors, "otp")}`}
               value={loginObj["otp"]}
               name="otp"
               onChange={(e) => handleChange(e, loginObj, errors, apiErrors)}></input>
        <span className={`input-close-button ${showCloseButtonClass(loginObj["otp"])}`}
                onClick={(e) => clearInput(e, "otp", loginObj, errors)}></span>
      </div>
      <ErrorMessageComponent inputField="otp"/>
      <ApiErrorMessageComponent />
      {showRegenerateOtp(resetOtpHandler, passwordReset, loginObj)}
    </div>
    <div className="buttons-container">
      {showButtonComponent({'name': 'Authenticate'}, onButtonClick, loginObj, passwordReset, source, errors, userLogin, action)}
      {showButtonComponent({'name': 'Back'}, onButtonClick, loginObj, passwordReset, source, errors, userLogin, action)}
    </div>
    </div>
  )
}

const showRegenerateOtp = (resetOtpHandler, passwordReset, loginObj) => {
  return(
    <div className="regenerate-otp">
      <span className="regenerate-otp__static">Didn’t receive OTP? </span>
      <span className="regenerate-otp__link" onClick={(e) => resetOtpHandler(e, passwordReset, loginObj)}>Resend OTP</span>
    </div>
  )
}

const showWrongOtpMessage = (resetOtpHandler, passwordReset, loginObj) => {
  return(
    <div className="regenerate-otp">
      <span>Did not get OTP? </span>
      <span onClick={(e) => resetOtpHandler(e, passwordReset, loginObj)}>Click to resend OTP</span>
    </div>
  )
}

const otpScreenHeader =(passwordReset, loginObj) => {
  const content = "A One Time Password (OTP) is sent to ";
  return(
    <div className="otp-header-text">
      <span className="otp-header-text__static">{content}</span>
      <span className="otp-header-text__email">{loginObj.email}</span>
    </div>
  )
}

const generateButtonComponent = (opts, onButtonClick, loginObj, passwordReset, source, errors, userLogin, action) => {
  return(
      <div className={`metype-button-container`}>
        <button type="submit" className={`metype-button ${opts.name}`} onClick={(e) => onButtonClick(e, loginObj, passwordReset, source, opts, errors, userLogin, action)}>
          {opts.name}
        </button>
      </div>
    )
}

const showButtonComponent = (opts, onButtonClick, loginObj={}, passwordReset, source, errors, userLogin, action) => {
  if((source === 'signUp' || source === 'emailConfirmation' || source === 'signIn') && opts.name === 'Authenticate') {
    return generateButtonComponent(opts, onButtonClick, loginObj, passwordReset, source, errors, userLogin, action)
  }
  else if(source !== 'signUp' && opts.name === 'Back') {
    return generateButtonComponent(opts, onButtonClick, loginObj, passwordReset, source, errors, userLogin, action)
  }
}

const mapStateToProps = ({formLoginReducers}) => {
  return {
    loginObj: formLoginReducers.loginObj,
    passwordReset: formLoginReducers.passwordReset,
    errors: formLoginReducers.errors,
    source: formLoginReducers.source
  }
}

const onResetPasswordOtp = (loginObj) => {
  resetPasswordOtp({email: loginObj.email}).then((response) => {
    success("", `<span> otp sent to your mail <strong>${loginObj.email}</strong></span>`, 25 , event.clientY, 600,'form-sso-pnotify');
  });
}

const onRegenerateOtp = (loginObj) => {
  regenerateOtp({email: loginObj.email}).then((response) => {
    success("", `<span> otp sent to your mail <strong>${loginObj.email}</strong></span>`, 25 , event.clientY, 600,'form-sso-pnotify');
  })
}

const onProgressButtonClick = (loginObj, passwordReset, dispatch, userLogin, action) => {
  const validateResponse = validate(loginObj, otpConstraints(), {fullMessages: false }) || {};
  dispatch({ type: 'ERRORS', ...validateResponse });

  actionOnValidation(validateResponse, passwordReset, loginObj, dispatch, userLogin, action);
}

const actionOnValidation = (validateResponse, passwordReset, loginObj, dispatch, userLogin, action) => {
  if(Object.keys(validateResponse).length === 0) {
    passwordReset ? onPasswordReset(dispatch, loginObj) : onOtpAuthentication(loginObj, dispatch, userLogin, action);
  }
}

const onPasswordReset = (dispatch, loginObj) => {
  dispatch({ type: 'LOGIN', ...loginObj, password: '' });
  onVerifyPasswordResetOtp(loginObj, dispatch);
}

const onVerifyPasswordResetOtp = (loginObj, dispatch) => {
  verifyPasswordResetOtp({email: loginObj.email, otp: loginObj.otp }).then((response) => {
    const responseCheck = response && response.is_otp_verified;
    responseCheck ? dispatch({ type: 'SCREEN', screen: 'resetPassword'})
                  : dispatch({ type: 'ERRORS', otp: ["Invalid email or OTP"] });
  }).catch((err) => {
    const responseBody = err.res.body.error;
    const errCode = err.res.statusCode;
    if(errCode === 401 && responseBody === "Invalid otp code") {
      dispatch({ type: 'ERRORS', otp: ["Invalid OTP"] })
    }
  });
}

const onOtpAuthentication = (loginObj, dispatch, userLogin, action) => {
  authenticateOtp({email: loginObj.email, otp: loginObj.otp })
  .then((response) => {
    response ? actionOnResponse(dispatch, response, loginObj, userLogin, action) : dispatch({ type: 'ERRORS',otp: ["Invalid OTP"]});
  });
}

const actionOnResponse = (dispatch, response, loginObj, userLogin, action) => {
  signInUserOnAuthentication(dispatch, loginObj, userLogin, action);
}

const signInUserOnAuthentication = (dispatch, loginObj, userLogin, action) => {
  signInUser( { user: { email: loginObj.email, password: loginObj.password }, sso: true})
  .then((response) => {
    dispatch({type: "LOGIN_SETUSER", currentUser: response.current_user, signedIn: response.success})
    redirectUserOnSignIn(dispatch, response, userLogin, action);
  });
}

const redirectUserOnSignIn = (dispatch, response, userLogin, action) => {
  if(response["sso_redirect_uri"]) {
    window.location.href =  response["sso_redirect_uri"]
  } else if(action && response.current_user) {
    userLogin();
    return;
  } else {
    window.location.href = "/"
  }
}

const onBackButtonClick = (dispatch, source) => {
  switch(source) {
    case 'signIn':
      dispatch({ type: 'ERRORS', errors: ""});
      dispatch({ type: 'SCREEN', screen: 'signin', source: ""});
      break;
    case 'emailConfirmation':
      dispatch({ type: 'ERRORS', errors: ""});
      dispatch({ type: 'SCREEN', screen: 'emailConfirmation', source: ""});
      break;
  }
}

const mapDispatchToprops = (dispatch, props) => {
  return {
    clearInput: (e, signinField, loginObj, errors) => {
      clearInputContent(e, signinField, loginObj, errors, dispatch);
    },
    handleChange: (e, loginObj={}, errors, apiErrors) => {
      dispatch({ type: 'LOGIN', ...loginObj, [e.target.name]: e.target.value});

      if(e.target.value.length === 0 && ((errors[e.target.name] && errors[e.target.name].length > 0))) {
        dispatch({ type: 'ERRORS', ...errors, [e.target.name]: ""});
      }
      if(e.target.value.length === 0 && Object.keys(apiErrors).length > 0) {
        dispatch({type: 'API_ERRORS', apiErrors: {}});
      }
    },
    resetOtpHandler: (e, passwordReset, loginObj) => {
      passwordReset ? onResetPasswordOtp(loginObj) : onRegenerateOtp(loginObj);
    },
    onButtonClick: (e, loginObj={}, passwordReset, source, opts, errors, userLogin, action) => {
      e.preventDefault();
      e.stopPropagation();

      (opts.name === 'Back') ? onBackButtonClick(dispatch, source) : onProgressButtonClick(loginObj, passwordReset, dispatch, userLogin, action);
    }
  }
}

export default connect(mapStateToProps, mapDispatchToprops)(OtpScreen);



// WEBPACK FOOTER //
// ./app/javascript/pages/page/form_login_modal/otp_screen_component/otp_screen_component.js